module.exports = __webpack_public_path__ + "img/input-number.86e77c8d.svg";